interface State {
  showSuccessPaymentPopup: { status: boolean; payload: any };
  showRemainingsPopup: boolean;
  loginPopup: any;
  loginManagerPopup: boolean;
  registrationPopup: any;
  resetPopup: any;
  restorePopup: any;
  restorePhonePopup: any;
  addressesListPopup: any;
  instagramPopup: any;
  successRegisterPopup: any;
  anotherCosmetolog: any;
  fastBuyPopup: any;
  showDefaultPrice: any;
  formApplicationPopup: any;
  paymentInfoPopup: any;
  successRegisterAgent: any;
  seminarDetails: any;
  textInfoModal: any;
  shoeNotifyWhenAvailable: any;
  showSeminarInfoPopup: boolean;
  showSeminarInfoContent: {
    title: string | null;
    description: string | null;
    buttonText: string | null;
    buttonLink: string | null;
  };
  seminarVideoModalStatus: boolean;
  seminarVideoModalUrl: string;
  showSeminarProfessionalOnlyPopup: boolean;
  reviewModalValue: any;
  showCosmoBaseFormPopup: boolean;
  showCosmoBaseSecondFormPopup: boolean;
  showCosmoBaseReviewPopup: boolean;
  showIFrameModal: boolean;
  showPushModal: boolean;
  pushModalContent: any;
  IFrameModalContent: string;
  showNotifyProductPopup: boolean;
  showReviewsForm: boolean;
  alreadyShowPushModal: boolean;
  showValentineModal: boolean;
  promotionNotificationPopup: { status: boolean; data: any };
}

const state: State = {
  seminarDetails: {
    status: false,
    data: "",
  },
  textInfoModal: {
    status: false,
    data: "",
  },
  shoeNotifyWhenAvailable: {
    status: false,
    data: "",
  },
  showSuccessPaymentPopup: {
    status: false,
    payload: { withSms: false, notCall: false, withWebinar: false },
  },
  showRemainingsPopup: false,
  loginPopup: false,
  loginManagerPopup: false,
  registrationPopup: false,
  resetPopup: false,
  restorePopup: false,
  restorePhonePopup: false,
  addressesListPopup: false,
  instagramPopup: false,
  showDefaultPrice: false,
  formApplicationPopup: false,
  paymentInfoPopup: false,
  showPushModal: false,
  pushModalContent: null,
  alreadyShowPushModal: false,
  successRegisterPopup: {
    show: false,
    text: "",
    code: "",
    percent: null,
  },
  anotherCosmetolog: false,
  fastBuyPopup: {
    show: false,
    product: null,
  },
  successRegisterAgent: false,
  showSeminarInfoPopup: false,
  showSeminarInfoContent: {
    title: null,
    description: null,
    buttonText: null,
    buttonLink: null,
  },
  seminarVideoModalStatus: false,
  seminarVideoModalUrl: "",
  showSeminarProfessionalOnlyPopup: false,
  reviewModalValue: null,
  showCosmoBaseFormPopup: false,
  showCosmoBaseSecondFormPopup: false,
  showCosmoBaseReviewPopup: false,
  showIFrameModal: false,
  IFrameModalContent: "",
  showNotifyProductPopup: false,
  showReviewsForm: false,
  showValentineModal: false,
  promotionNotificationPopup: { status: false, data: null },
};

const getters = {
  shoeNotifyWhenAvailable: (state: State) => state.shoeNotifyWhenAvailable,
  showSuccessPaymentPopup: (state: State) => state.showSuccessPaymentPopup,
  loginPopup: (state: State) => state.loginPopup,
  loginManagerPopup: (state: State) => state.loginManagerPopup,
  registrationPopup: (state: State) => state.registrationPopup,
  resetPopup: (state: State) => state.resetPopup,
  restorePopup: (state: State) => state.restorePopup,
  restorePhonePopup: (state: State) => state.restorePhonePopup,
  addressesListPopup: (state: State) => state.addressesListPopup,
  instagramPopup: (state: State) => state.instagramPopup,
  successRegisterPopup: (state: State) => state.successRegisterPopup,
  anotherCosmetolog: (state: State) => state.anotherCosmetolog,
  fastBuyPopup: (state: State) => state.fastBuyPopup,
  showDefaultPrice: (state: State) => state.showDefaultPrice,
  formApplicationPopup: (state: State) => state.formApplicationPopup,
  paymentInfoPopup: (state: State) => state.paymentInfoPopup,
  successRegisterAgent: (state: State) => state.successRegisterAgent,
  seminarDetails: (state: State) => state.seminarDetails,
  textInfoModal: (state: State) => state.textInfoModal,
  showRemainingsPopup: (state: State) => state.showRemainingsPopup,
  showSeminarInfoPopup: (state: State) => state.showSeminarInfoPopup,
  showSeminarInfoContent: (state: State) => state.showSeminarInfoContent,
  seminarVideoModalStatus: (state: State) => state.seminarVideoModalStatus,
  seminarVideoModalUrl: (state: State) => state.seminarVideoModalUrl,
  showSeminarProfessionalOnlyPopup: (state: State) => state.showSeminarProfessionalOnlyPopup,
  reviewModalPayload: (state: State) => state.reviewModalValue.payload,
  reviewModalStatus: (state: State) => state.reviewModalValue?.status || false,
  showCosmoBaseFormPopup: (state: State) => state.showCosmoBaseFormPopup,
  showCosmoBaseReviewPopup: (state: State) => state.showCosmoBaseReviewPopup,
  showCosmoBaseSecondFormPopup: (state: State) => state.showCosmoBaseSecondFormPopup,
  showIFrameModal: (state: State) => state.showIFrameModal,
  showPushModal: (state: State) => state.showPushModal,
  pushModalContent: (state: State) => state.pushModalContent,
  IFrameModalContent: (state: State) => state.IFrameModalContent,
  showNotifyProductPopup: (state: State) => state.showNotifyProductPopup,
  showReviewsForm: (state: State) => state.showReviewsForm,
  showValentineModal: (state: State) => state.showValentineModal,
  promotionNotificationPopup: (state: State) => state.promotionNotificationPopup,
};

const actions = {};

const mutations = {
  CHANGE_IFRAME_MODAL(state: State, payload: { status: boolean; iframe: string }) {
    state.showIFrameModal = payload.status;
    state.IFrameModalContent = payload.iframe;
  },
  CHANGE_PUSH_MODAL(state: State, payload: { status: boolean; response: any }) {
    if (payload.status && !state.alreadyShowPushModal) {
      state.alreadyShowPushModal = true;
      state.showPushModal = payload.status;
      state.pushModalContent = payload.response;
      return;
    }
    state.showPushModal = false;
    (window as any).gtag("event", "sales_popup_close", {
      popup_name: "outlet_sale",
    });
  },
  CHANGE_NOTIFY_PRODUCT_POPUP(state: State, status: boolean) {
    state.showNotifyProductPopup = status;
  },
  CHANGE_DEFAULT_PRICES(state: State, status: any) {
    state.showDefaultPrice = status;
  },
  CHANGE_COSMOBASE_FORM_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.showCosmoBaseFormPopup = status;
  },
  CHANGE_COSMOBASE_REVIEW_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.showCosmoBaseReviewPopup = status;
  },
  CHANGE_COSMOBASE_SECOND_FORM_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.showCosmoBaseSecondFormPopup = status;
  },
  CHANGE_FAST_BUY_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.fastBuyPopup = status;
  },
  CHANGE_LOGIN_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.loginPopup = status;
  },
  CHANGE_LOGIN_MANAGER_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.loginManagerPopup = status;
  },
  CHANGE_ADDRESSES_LIST_POPUP(state: State, status: any) {
    if (status === state.addressesListPopup) return;
    document.getElementById("html")?.classList.remove("hide");
    state.addressesListPopup = status;
  },
  CHANGE_REGISTRATION_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.registrationPopup = status;
  },
  CHANGE_RESET_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.resetPopup = status;
  },
  CHANGE_RESTORE_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.restorePopup = status;
  },
  CHANGE_RESTORE_PHONE_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.restorePhonePopup = status;
  },
  CHANGE_INSTAGRAM_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.instagramPopup = status;
  },
  CHANGE_SUCCESS_REGISTER_POPUP(state: State, data: any) {
    document.getElementById("html")?.classList.remove("hide");
    Object.assign(state.successRegisterPopup, data);
  },
  CHANGE_COSMETOLOG_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.anotherCosmetolog = status;
  },
  CHANGE_APPLICATION_FORM_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.formApplicationPopup = status;
  },
  CHANGE_PAYMENT_INFO_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.paymentInfoPopup = status;
  },
  CHANGE_SHOW_SUCCESS_AGENT_REGISTER(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.successRegisterAgent = status;
  },
  CHANGE_REMAININGS_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.showRemainingsPopup = status;
  },
  SHOW_SEMINAR_INFO_POPUP(state: State, status: any) {
    document.getElementById("html")?.classList.remove("hide");
    state.showSeminarInfoPopup = status;
  },
  SET_SEMINAR_INFO_CONTENT(
    state: State,
    data: { title: string | null; description: string | null; buttonText?: string | null; buttonLink?: string | null }
  ) {
    state.showSeminarInfoContent = {
      title: data.title,
      description: data.description,
      buttonText: data.buttonText || null,
      buttonLink: data.buttonLink || null,
    };
  },
  SHOW_SUCCESS_PAYMENT_POPUP(state: State, payload: any = {}) {
    state.showSuccessPaymentPopup.status = payload.status;
    state.showSuccessPaymentPopup.payload = payload;
  },
  SHOW_SEMINAR_DETAILS_POPUP(state: State, data: any) {
    state.seminarDetails = data;
  },
  CHANGE_TEXT_INFO_MODAL(state: State, data: any) {
    state.textInfoModal = data;
  },
  SHOW_TEXT_MODAL(state: State, data: any) {
    state.seminarDetails = data;
  },
  SHOW_NOTIFY_WHEN_AVAILABLE(state: State, data: any) {
    state.shoeNotifyWhenAvailable = data;
  },
  SHOW_SEMINAR_VIDEO_MODAL(state: State, data: any) {
    state.seminarVideoModalUrl = data.link;
    state.seminarVideoModalStatus = data.status;
  },
  SHOW_SEMINAR_PROFESSIONAL_ONLY_POPUP(state: State, status: boolean) {
    state.showSeminarProfessionalOnlyPopup = status;
  },
  CHANGE_REVIEW_MODAL(state: State, payload: any = {}) {
    state.reviewModalValue = payload;
  },
  CHANGE_REVIEW_FORM_STATUS(state: State, payload: any = {}) {
    state.showReviewsForm = payload;
  },
  CHANGE_VALENTINE_MODAL(state: State, status: boolean) {
    state.showValentineModal = status;
  },
  CHANGE_PROMOTION_NOTIFICATION_POPUP(state: State, payload: { status: boolean; data?: any }) {
    state.promotionNotificationPopup.status = payload.status;
    state.promotionNotificationPopup.data = payload.data || null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
